import axios from "utils/axios";
import queryString from "query-string";

export const getCountries = (params) => {
  const query = queryString.stringify(params);
  return axios.get(`/countries?${query}`);
};

export const getProvinces = (params) => {
  const query = queryString.stringify(params);
  return axios.get(`/provinces?${query}`);
};

export const getCities = (params) => {
  const query = queryString.stringify(params);
  return axios.get(`/cities?${query}`);
};
